export default __webpack_public_path__ + "static/media/invited_icon.db043b02.svg";